import { Grid, styled } from "@mui/material";
import MxDetailSmallCard from "../MxDetailCardSmall";
import { IconAlertCircle } from "@tabler/icons-react";
import MxIcons from "@rf-l1/MxIcons";
import MxTypography from "@rf-l1/MxTypography";

export interface RemaxGlobalStatusSync {
  syncStatus: "Sincronizado" | "Incompleto" | "Fallido";
  syncErrorMessage: {
    level: string;
    code: string;
    message: string;
  }[];
}
export interface MxDetailCardRemaxGlobalProps {
  title?: string;
  status: RemaxGlobalStatusSync;
}

const MxDetailCardRemaxGlobal = (props: MxDetailCardRemaxGlobalProps) => {
  console.log(props.status);
  if (!props?.status?.syncStatus) {
    return null;
  }
  return (
    <MxDetailSmallCard title={props.title || "REMAX GLOBAL"}>
      <Grid container rowGap={2}>
        <Grid
          container
          item
          xs={12}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item xs="auto">
            <MxTypography variant="body2" color="grey.700">
              Estado de sincronización
            </MxTypography>
          </Grid>
          <Grid item xs="auto">
            <MxTypography
              variant="body2"
              fontWeight={500}
              color={
                {
                  Sincronizado: "success.main",
                  Incompleto: "warning.main",
                  Fallido: "error.main"
                }[props.status.syncStatus]
              }
            >
              {props.status.syncStatus || "Sincronizado"}
            </MxTypography>
          </Grid>
        </Grid>

        <Grid container item xs={12} rowGap={1}>
          {props.status?.syncErrorMessage?.map((x, index) => (
            <AlertCard item xs={12} key={index}>
              <MxIcons children={<IconAlertCircle />} size={16} />
              <MxTypography variant="caption">{x.message}</MxTypography>
            </AlertCard>
          ))}
        </Grid>
      </Grid>
    </MxDetailSmallCard>
  );
};

export default MxDetailCardRemaxGlobal;

const AlertCard = styled(Grid)(({ theme }) => ({
  width: "100%",
  minHeight: 35,
  backgroundColor: theme.palette.warning.light + "20",
  borderRadius: 4,
  padding: 5,
  color: theme.palette.warning.main,
  display: "flex",
  alignItems: "center",
  gap: 10,
  svg: {
    marginBottom: 2
  }
}));
